import { render, staticRenderFns } from "./CustomErrorCard.vue?vue&type=template&id=0315d3db&scoped=true"
import script from "./CustomErrorCard.vue?vue&type=script&lang=js"
export * from "./CustomErrorCard.vue?vue&type=script&lang=js"
import style0 from "./CustomErrorCard.vue?vue&type=style&index=0&id=0315d3db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315d3db",
  null
  
)

export default component.exports